module.exports = __webpack_public_path__ + "img/Arrow-Side.8ee59556.svg";